






























































































import { Component, Prop, Vue } from "vue-property-decorator";
import StripeApi from "@/services/StripeApi";
import TooltipModule from "@/store/tooltip";
import CTooltip from "@/components/CTooltip.vue";
import logger from "@/lib/log/logger";

@Component({
  components: {
    CTooltip,
  },
})
export default class CustomerForm extends Vue {
  // 入力フォーム初期値
  private form = {
    cusId: "",
    email: "",
    name: "",
  };

  // メールアドレス確認v-model
  private cfmEmail = "";

  // エラーモーダル表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  @Prop({ type: String, required: true })
  cusId: string | undefined;

  // 「送信」clickで実行
  private async submit() {
    if (this.cusId) {
      this.form.cusId = this.cusId;
    }
    try {
      await StripeApi.instance.updateCustomer(this.form);
      this.$router.push({ name: "URegisterPayment" });
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }
}
